/**
 * Cycle designer phase — when cycle_designer_v2 is enabled, new cycles use the
 * visual Cycle Designer instead of CycleSetupWizard until launch completes.
 */

import type { DegapCycle } from '@/types/prioritization/degapCycle';

export const DESIGNER_LAUNCHED_AT_KEY = 'designerLaunchedAt';

export function getDesignerLaunchedAt(cycle: DegapCycle | null | undefined): string | null {
  if (!cycle?.metadata || typeof cycle.metadata !== 'object') return null;
  const value = (cycle.metadata as Record<string, unknown>)[DESIGNER_LAUNCHED_AT_KEY];
  return typeof value === 'string' && value.length > 0 ? value : null;
}

export function isCycleDesignerComplete(cycle: DegapCycle | null | undefined): boolean {
  return Boolean(getDesignerLaunchedAt(cycle));
}

export interface ShouldUseCycleDesignerInput {
  cycle: DegapCycle | null | undefined;
  userId: string | null | undefined;
  isCycleOwner: boolean;
  isAdmin: boolean;
  advancedMode?: boolean;
  designerEnabled: boolean;
}

export function shouldUseCycleDesigner(input: ShouldUseCycleDesignerInput): boolean {
  const { cycle, userId, isCycleOwner, isAdmin, advancedMode, designerEnabled } = input;
  if (!designerEnabled) return false;
  if (!cycle || !userId) return false;
  if (advancedMode) return false;
  if (!isCycleOwner && !isAdmin) return false;
  return !isCycleDesignerComplete(cycle);
}

export function mergeDesignerLaunchedMetadata(
  cycle: DegapCycle,
  launchedAt: string = new Date().toISOString(),
  extra: Record<string, unknown> = {},
): Record<string, unknown> {
  const existing =
    cycle.metadata && typeof cycle.metadata === 'object'
      ? { ...(cycle.metadata as Record<string, unknown>) }
      : {};
  return { ...existing, ...extra, [DESIGNER_LAUNCHED_AT_KEY]: launchedAt };
}
